/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

export const getBrandFromPartNumber = (partNumber) => {
    if (partNumber.includes('-')) {
        return partNumber.split('-')[0];
    }
    return partNumber.split('_')[0];
};

export default {};
